import React, { useEffect, useMemo, useState } from "react";
import { api } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Textarea } from "../../components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../../components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { Checkbox } from "../../components/ui/checkbox";
import { toast } from "sonner";

export default function IssueDialog({ item, onClose, onDone }) {
  const [qty, setQty] = useState(1);
  const [note, setNote] = useState("");
  const [projectId, setProjectId] = useState("");
  const [projects, setProjects] = useState([]);
  const [busy, setBusy] = useState(false);
  const available = parseFloat(item.quantity) || 0;

  useEffect(() => {
    api.get("/projects").then(({ data }) => setProjects(data || [])).catch(() => {});
  }, []);

  const submit = async () => {
    const q = parseFloat(qty);
    if (!q || q <= 0) { toast.error("Introdu cantitate validă"); return; }
    if (q > available) { toast.error(`Disponibil doar ${available} ${item.unit || "buc"}`); return; }
    setBusy(true);
    try {
      await api.post(`/inventory/${item.id}/issue`, {
        quantity: q,
        note: note.trim() || null,
        project_id: projectId || null,
      });
      toast.success(`Preluat ${q} ${item.unit || "buc"} din ${item.name}`);
      onDone?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Eroare la preluare");
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={true} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="issue-dialog">
        <DialogHeader><DialogTitle>Preia din magazie · {item.name}</DialogTitle></DialogHeader>
        <div className="space-y-3 text-sm">
          <div className="card-flat p-3 bg-zinc-50">
            <div className="flex justify-between">
              <span className="text-zinc-500">Disponibil acum</span>
              <strong>{available} {item.unit || "buc"}</strong>
            </div>
            {(item.shelf_row || item.shelf_col) && (
              <div className="flex justify-between mt-1">
                <span className="text-zinc-500">Locație</span>
                <span className="font-mono text-xs">{item.location || "—"} · {item.shelf_row || "-"}{item.shelf_col || ""}</span>
              </div>
            )}
          </div>
          <div>
            <Label>Cantitate de preluat</Label>
            <Input type="number" min={0.01} step={0.01} max={available} value={qty} onChange={(e) => setQty(e.target.value)} data-testid="issue-qty-input" />
          </div>
          <div>
            <Label>Proiect (opțional)</Label>
            <Select value={projectId || "__none__"} onValueChange={(v) => setProjectId(v === "__none__" ? "" : v)}>
              <SelectTrigger className="mt-1"><SelectValue placeholder="Pentru ce șantier/proiect?" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="__none__">— Niciunul —</SelectItem>
                {projects.map((p) => <SelectItem key={p.id} value={p.id}>{p.title}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label>Notă (opțional)</Label>
            <Textarea rows={2} value={note} onChange={(e) => setNote(e.target.value)} placeholder="ex: schimbat la auto X" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Anulează</Button>
          <Button onClick={submit} disabled={busy} className="bg-[var(--primary)]" data-testid="issue-confirm">{busy ? "Se preia…" : "Confirmă preluarea"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
